// @flow
import styled from 'styled-components';
import Grid from 'styled-components-grid';
import breakpoint from 'styled-components-breakpoint';
import {
  py, m, mb, pb, p, pr, px
} from 'styled-components-spacing';
import theme from '@theme';

const { colors } = theme;

export const StyledWrapper = styled(Grid.Unit)`
   ${p(4)}
  ${breakpoint('mobile', 'tablet')`
    ${px(2.5)}
    ${py(3)}
  `}

  ${breakpoint('tablet', 'desktop')`
    ${px(3)}
    ${py(4)}
  `}

  ${breakpoint('desktop')`
    @media only screen and (min-width: 1024px) and (max-width: 1240px){
      ${px(3)}
      ${py(4)}
    } 
  `}
`;

export const StyledListItem = styled(Grid)`
  max-width: 490px;
  background-color: ${colors.white};
  border-radius: 10px;
  justify-content: center;
  box-shadow: ${props => (props.facilityPage ? 'none' : `0 2px 8px 0 ${colors.mediumGray}`)};
  ${props =>
    props.facilityPage
    && `
      border: 2px solid #BDBCBC;
  `}
  margin: 0 auto;
  overflow: hidden;
`;

export const StyledTextContainer = styled(Grid)`
  display: flex;
  flex-direction: column;
  ${m(2)};
  ${p(2)}
  cursor: default;
  width: 100%;
  ${breakpoint('mobile', 'desktop')`
  ${m(1)};
  ${p(1)}
  @media only screen and (min-width: 0) and (max-width: 300px) {
    padding-bottom: 0px;
    margin-bottom: 0px;
  }
  `}
  min-width: 0;
`;

export const StyledImageContainer = styled.div`
  width: calc(100% - 15px);
  margin: 0 auto;
  margin-top: 7.5px;
  ${breakpoint('mobile', 'tablet')`
  width: calc(100% - 10px);
  margin-top: 5px;
  `}
  ${props =>
    props.facilityPage
    && ` width:100%;
     margin: 0;
  }`
}
`;

export const StyledHeadline = styled.div`
 margin: 0 auto;
 text-align: ${props => (props.facilityPage ? '' : 'center')};
 font-size: 17px;
 font-weight: bold;
 min-height: ${props => (props.facilityPage ? '' : '60px')};
 line-height: 1.5;
 ${props => (props.facilityPage ? '' : pb(3))};
 ${breakpoint('mobile', 'tablet')`
  font-size: ${props => (props.facilityPage ? '15px' : '12px')};
  letter-spacing: 0.3;
  line-height:${props => (props.facilityPage ? '1.2' : '1rem')};
  min-height:${props => (props.facilityPage ? '' : ' 45px')}
  ${pb(1)};
 margin - bottom: ${props => (props.facilityPage ? '0.5rem' : '')};
`}
  color: ${colors.darkBlue};


`;

export const StyleText = styled.span`
  color: ${colors.darkGreen};
  font-weight: 700;
  letter-spacing: 0.3px;
`;

export const StyledLink = styled.a`
  text-decoration: none;
  width: calc(100% - 20px);
  margin: 0 auto;
  ${mb(3)}
  color: ${colors.darkBlue};
  transition: 0.3s;
  :hover {
    color: ${colors.blueNavi};
  }

  ${props =>
    props.facilityPage
    && `display:flex;
    justify-content: center;
     :hover {
        color: '#287FB0';
  }
  `}

  ${props =>
    props.Image
    && `width: 100%;
    height: 100%;
  `}
  ${breakpoint('mobile', 'tablet')`
  ${mb(2)}
  width: calc(100% - 16px);
  `}
`;
export const StyledBookButton = styled.button`
  font-size: ${props => (props.facilityPage ? '23px' : '16px')};
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  letter-spacing: 0.5px;
  border-radius: 8px;
  transition: all 0.3s ease 0s;
  
  letter-spacing: 0.5px;
  cursor: pointer;
  /* color: ${colors.aquaMarine}; */
  color:${props => (props.facilityPage ? 'white' : colors.aquaMarine)};
  background: ${props => (props.facilityPage ? '#287FB0' : 'transparent')};
  /* background-color: transparent; */
  border: solid 1.5px ${props => (props.facilityPage ? '' : colors.aquaMarine)};
  ${py(2)};
  ${px(1)};
  width: ${props => (props.facilityPage ? '90%' : '100%')};
  ${props => (props.facilityPage && `
    padding: 10px;
  `)}
  :hover {
    background-color: ${props => (props.facilityPage ? ' #1d5c81' : colors.aquaMarine)};
    color: ${colors.white};
  }
  ${breakpoint('mobile', 'tablet')`
  font-size: ${props => (props.facilityPage ? '15px' : '13px')};
  border-radius: 6px;
  ${props => (props.facilityPage ? py(2) : py(1))};

 `}
`;

export const StyledPriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const StyledActualPriceWrapper = styled.div`
  font-size: 16px;
  ${pr(1)};
  text-decoration: line-through;
  ${breakpoint('mobile', 'tablet')`
  font-size: ${props => (props.facilityPage ? '13px' : '10px')};
  ${pr(1)};
  padding-left:2px;
  @media only screen and (min-width: 300px) and (max-width: 390px) {
    font-size:10px;
    padding-left:0;
  }
  @media only screen and (min-width: 0) and (max-width: 360px) {
    padding-right:2px;
    font-size:8px;
    padding-left:0;
  }
`};
`;

export const StyledFinalPriceWrapper = styled.div`
  font-size: 18px;
  ${px(1)};
  font-weight: bold;
  color:${props => (props.facilityPage ? '#0F86BA' : colors.aquaMarine)};

  ${breakpoint('mobile', 'tablet')`
  font-size: ${props => (props.facilityPage ? '14px' : '12px')};
  @media only screen and (min-width: 0) and (max-width: 350px) {
    font-size:10px;
  }
  ${px(0)};
  ${pr(1)};
`};
  @media only screen and (min-width: 0) and (max-width: 360px) {
    ${pr(0)};
    padding-right: 2px;
    font-size: 9px;
  }
`;

export const StyledItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 30px;
  font-size: 15px;
  line-height: 1.4;
  color: ${colors.darkestGray};
  ${py(2)};

  ${breakpoint('mobile', 'tablet')`
    font-size: ${props => (props.facilityPage ? '13px' : '10px')};
    height: 20px;
    ${py(1)};
    @media only screen and (min-width: 0) and (max-width: 300px) {
      font-size: 9px;
    }
  `};
`;

export const StyledPackageIcon = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
padding-right: 2px;
align-items: center;
  svg {
    ${pr(2)};
    height: 20px;
    width: 20px;
  }
  min-height: 20px;

  ${breakpoint('mobile', 'tablet')`
  svg {
    ${pr(1)};
    height: ${props => (props.facilityPage ? '19px' : '16px')}
    min-height: 14px;
    min-width: 12px;
    width: ${props => (props.facilityPage ? '23px' : '20px')};
  }
  @media only screen and (min-width: 0) and (max-width: 320px) {
    padding-right:0px;
  }
  @media only screen and (min-width: 320px) and (max-width: 360px) {
    padding-right:2px;
    svg{
      height:12px;
      min-height: 10px;
      width:100%;
    }
  }
`};
@media only screen and (min-width: 1024px) and (max-width: 1190px) {
  svg, path, rect{
    height: 20px;
    width: 100%;
    min-height: 16px;
    min-width:20px;
  }
}
`;

export const StyledPrice = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;
